import useSWR from 'swr';
import { EngineService } from '@/services/engine';
import { getVehicleCacheKey } from '@/constants/cache-keys';
import type { Vehicle } from '@/types';

interface UseVehicleDataParams {
    vehicleId: string | undefined;
}

export function useVehicleData({ vehicleId }: UseVehicleDataParams) {
    const {
        data: vehicle,
        error,
        isLoading,
        mutate,
    } = useSWR<Vehicle>(vehicleId ? getVehicleCacheKey(vehicleId) : null, () =>
        EngineService.getVehicle(vehicleId!),
    );

    return { vehicle, error, isLoading, mutate };
}
